import { Component } from "react";
import * as Scrivito from "scrivito";

class IntroPageWidget extends Component {
  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  render() {
    const { widget } = this.props;
    const buttonText = widget.get("buttonText");
    return (
      <div className="d-flex flex-column align-items-center ">
        <div className="form-intro-headline">
          <Scrivito.ContentTag
            tag="h2"
            content={widget}
            attribute="headline"
            className="headline-form"
          />
        </div>
        <div className="form-intro-hint">
          <Scrivito.ContentTag
            tag="h6"
            content={widget}
            attribute="hint"
            className="hint-form"
          />
          <button className="btn btn-primary" onClick={this.continue}>
            {buttonText}
          </button>
        </div>
      </div>
    );
  }
}

Scrivito.provideComponent("IntroPageWidget", IntroPageWidget);
